import { api } from '@/apis';

import { useCoreQuery } from '../core';
import { keys } from '../keys';

/**
 * 장바구니 조회
 * @param cart_group_ids
 * @returns
 */
export const useCartQuery = (cart_group_ids?: number[]) =>
  useCoreQuery(keys.cart.carts(cart_group_ids), () =>
    api.cart.getCarts(cart_group_ids).then((res) => res),
  );

/**
 * 장바구니 수 조회
 */
export const useCartCountQuery = () =>
  useCoreQuery(keys.cart.count(), () => api.cart.getCartCount().then((res) => res));
